import { PhoneValidationErrorCode } from '../enum/ui-utils.enum';
import { EnumOptionInterface, EnumOptionProperties } from '../models/ui.model';

export const HTTP_RESPONSE_ERROR_MESSAGE = 'error.networkError';
export const SESSION_EXPIRED_ERROR_MESSAGE = 'error.sessionExpired';

export const PHONE_VALIDATION_ERROR_OPTIONS: EnumOptionInterface = {
    [PhoneValidationErrorCode.Null]: {
        label: 'error.phoneNumberRequired',
    },
    [PhoneValidationErrorCode.InvalidCountryCode]: {
        label: 'phoneErrorCode.inValidCountryCode',
    },
    [PhoneValidationErrorCode.IsPossible]: {
        label: 'phoneErrorCode.isPossible',
    },
    [PhoneValidationErrorCode.IsPossibleLocalOnly]: {
        label: 'phoneErrorCode.isPossibleLocalOnly',
    },
    [PhoneValidationErrorCode.InvalidLength]: {
        label: 'phoneErrorCode.invalidLength',
    },
    [PhoneValidationErrorCode.TooShort]: {
        label: 'phoneErrorCode.tooShort',
    },
    [PhoneValidationErrorCode.TooLong]: {
        label: 'phoneErrorCode.tooLong',
    },
};

export function getPhoneValidationErrorOptions(option: PhoneValidationErrorCode): EnumOptionProperties {
    return PHONE_VALIDATION_ERROR_OPTIONS[option] || new EnumOptionProperties();
}
